import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingBoxBase, SettingBoxPositionTable } from '../../../app/components/settings-drawer';
import { useLiquidityCashWithJbSettings, useUpdateLiquidityCashWithJbItemSettings, useUpdateLiquidityCashWithJbPanelSettings } from '../../api';
import { useLiquidityScopeUpdating, useLiquiditySelectedBankableAssets } from '../../hooks';

interface IProps {
    expandedKey?: string;
}

export const LiquidityCashWithJbSettings: FunctionComponent<IProps> = ({ expandedKey }) => {
    const { t } = useTranslation();
    const totalSelectedBankableAssets = useLiquiditySelectedBankableAssets();
    const { data: cashWithJbSettings, isFetching } = useLiquidityCashWithJbSettings();
    const isScopeUpdating = useLiquidityScopeUpdating();

    const updateCashWithJbSettings = useUpdateLiquidityCashWithJbPanelSettings();
    const updateCashWithJbItemSettings = useUpdateLiquidityCashWithJbItemSettings();

    return (
        <SettingBoxBase
            title={t('liquidityCalculatorSettings.cashWithJb')}
            showWarningIcon={totalSelectedBankableAssets <= 0}
            warningText={t('noBankableAssetsWarning')}
            boxId={cashWithJbSettings?.id}
            sectionKey="cashWithJb"
            expandedKey={expandedKey}
            toggled={cashWithJbSettings?.enabled}
            onToggle={updateCashWithJbSettings}
            detail={
                <SettingBoxPositionTable
                    enabled={!!cashWithJbSettings?.enabled}
                    updateItemSettings={updateCashWithJbItemSettings}
                    itemSettings={cashWithJbSettings?.itemsSettings ?? []}
                    totalAmount={cashWithJbSettings?.totalAmount ?? 0}
                    emptyStateMessage={t('liquidityCalculatorSettings.emptyCashWithJb')}
                    isUpdating={isFetching || isScopeUpdating}
                />
            }
        />
    );
};
